import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6aaebc1f"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aaebc1f')) {
      api.createRecord('6aaebc1f', component.options)
    } else {
      api.reload('6aaebc1f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6aaebc1f", function () {
      api.rerender('6aaebc1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/platformCoupon/index.vue"
export default component.exports